$(function () {
    $('.kitAddToCart').AddToCart({
        loadingControlOptions: {
            loadingText: '',
            loadingTextTag: 'span',
            inheritToggledElementClass: true
        }
    });

    $('.bundle-card__bullets-toggle').click(function () {
        $(this).toggleClass("active");
        $(this).next('.bundle-card__bullets').toggleClass("expanded");
    });

});

(function bcToggle(){
    var togglers = document.querySelectorAll(".bundle-card__item-toggle");

    [].forEach.call(togglers, function(toggler){
        var trigger = toggler.querySelector(".bundle-card__item-toggle-trigger");

        trigger.addEventListener("click", function (e) {
            [].forEach.call(togglers, function (toggler) {
                toggler.classList.toggle("active");
            });
            $.fn.matchHeight._update();
        });
    });
}());
